module.exports = __webpack_public_path__ + "img/sm.a31a9a27.png";